var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getFormattedDate } from 'common/helpers/get-formatted-date';
export var notificationDrawerServiceIsOpenSelector = function (state) { return Boolean(state.isOpen); };
export var notificationDrawerServiceDataSelector = function (state) {
    if (!state.content.length) {
        return [];
    }
    var allContent = state.content.map(function (el) { return __spreadArray([], el.content, true); }).flat();
    return allContent.flat().map(function (el) { return (__assign(__assign({}, el), { createdOn: getFormattedDate(el.createdOn, 'Pp') })); });
};
export var notificationDrawerServiceLoadingSelector = function (state) { return Boolean(state.loading); };
export var notificationDrawerServiceLastNotificationDateSelector = function (state) { return state.lastNotificationDate; };
export var notificationDrawerServiceIsNotReadSelector = function (state) { return Boolean(state.onlyNotRead); };
export var notificationDrawerServicePageSizeSelector = function (state) { return Number(state.pageSize); };
export var notificationDrawerServiceTotalPagesSelector = function (state) { return Number(state.totalPages || 1); };
export var notificationDrawerServiceCurrentPageSelector = function (state) {
    return Number(state.content.length ? state.content.length - 1 : 0);
};
export var notificationDrawerServiceInitializedSelector = function (state) { return Boolean(state.initialized); };
